<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-tabs v-model="activeKey">
            <el-tab-pane label="包含国家" name="country_include"></el-tab-pane>
            <el-tab-pane label="排除国家" name="country_exclude"></el-tab-pane>
        </el-tabs>
        <div class="search">
            <div style="margin-bottom: 16px; float: right;">
                <el-button type="primary" size="small" @click="showAddDialog">新增国家</el-button>
            </div>
        </div>
        <!-- 列表 -->
        <el-table border v-bind:data="currentList">
            <el-table-column label="国家码">
                <template v-slot="scope">
                    <span>{{ scope.row.country_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="国家名称">
                <template v-slot="scope">
                    <span>{{ getCountryName(scope.row.country_code) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300px">
                <template v-slot="scope">
                    <el-button type="danger" size="small" @click="delCountry(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 新增弹窗 -->
        <el-dialog v-model="dialogVisible" :title="activeKey === 'country_include' ? '新增包含国家' : '新增排除国家'"
            width="500px" :close-on-click-modal="false">
            <el-form ref="formRef" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="国家" prop="country_code">
                    <el-select v-model="form.country_code" multiple filterable clearable placeholder="请选择国家"
                        style="width: 100%">
                        <el-option v-for="item in countryList" :key="item.code"
                            :label="item.chinese + '(' + item.code + ')'" :value="item.code" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitForm">确定</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../../axios/pack'
export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            Packcode: '',
            activeKey: 'country_include',
            list: [],
            countryList: [],
            dialogVisible: false,
            form: {
                country_code: []
            },
            rules: {
                country_code: [
                    { required: true, message: '请选择国家', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        currentList() {
            return this.list.filter(item => item.item_key === this.activeKey)
        },
        countryMap() {
            const map = {}
            this.countryList.forEach(item => {
                const key = String(item.code)
                if (!map[key]) {
                    map[key] = []
                }
                map[key].push(item.chinese)
            })
            return map
        }
    },
    watch: {},
    methods: {
        getCountryName(code) {
            const names = this.countryMap[String(code)]
            return names ? names.join('/') : ''
        },
        // 获取国家列表
        getCountryList() {
            this.api.CountryList({
                page: 1,
                limit: 500
            }).then(res => {
                if (res.data.code == 200) {
                    this.countryList = res.data.data.data
                    return
                }
                this.$message.error('获取国家列表失败' + res.data.msg)
            })
        },
        // 获取套餐关联国家列表
        countryList_(callback) {
            api.PackCountryList({
                set_meal_code: this.Packcode
            }).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data || []
                    callback && callback()
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        Search() {
            this.countryList_()
        },
        showAddDialog() {
            this.dialogVisible = true
            this.form = {
                country_code: []
            }
        },
        submitForm() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    api.PackCountrySet({
                        set_meal_code: this.Packcode,
                        item_key: this.activeKey,
                        country_code: this.form.country_code.map(code => String(code))
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('新增成功')
                            this.dialogVisible = false
                            this.Search()
                            return
                        }
                        this.$message.error('新增失败' + res.data.msg)
                    })
                } else {
                    return false
                }
            })
        },
        delCountry(item) {
            this.$confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                api.PackCountryDelete({
                    set_meal_code: this.Packcode,
                    item_key: item.item_key,
                    country_code: [String(item.country_code)]
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('删除成功')
                        this.Search()
                        return
                    }
                    this.$message.error('删除失败' + res.data.msg)
                })
            }).catch((e) => {
                console.log(e)
                this.$message.info('已取消')
            })
        },
        goback() {
            this.$router.push('/iot/pack')
        }
    },
    filters: {},
    mounted() {

    },
    created() {
        this.Packcode = this.$route.params.code
        this.Search()
        this.getCountryList()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
</style>
